import axios from 'axios';

export default {
  getWhitelabels({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/whitelabel/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertWhitelabels', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addWhitelabel({ commit, state }, { formData, event }) {
    return new Promise((resolve, reject) => {
      commit('addWhitelabelRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/whitelabel/add`,
        data: formData,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error(resp?.data?.message));
            return;
          }
          commit('addWhitelabelRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addWhitelabelRequestError', err);
          reject(err);
        });
    });
  },
  editWhitelabel({ commit, state }, { formData, event }) {
    return new Promise((resolve, reject) => {
      commit('editWhitelabelRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/whitelabel/edit`,
        data: formData,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editWhitelabelRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editWhitelabelRequestError', err);
          reject(err);
        });
    });
  },
  deleteWhitelabel({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      commit('deleteWhitelabelRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/whitelabel/destroy`,
        params: params,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deleteWhitelabelRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deleteWhitelabelRequestError', err);
          reject(err);
        });
    });
  }
};
